import permissions from '../../permissions'

const EXPORT_RIPD_LIST = [
  {
    name: 'Permitir/Negar acesso ao menu',
    tag: permissions.RIPD.EXPORT_ADMIN,
  },
]

export default EXPORT_RIPD_LIST
